import { createPortal } from "react-dom";
import { usePortal } from "./hooks/use-portal.hook";

interface PortalProps {
  children: React.ReactNode;
  id?: string;
}

export function Portal({ children, id = "portal-container" }: PortalProps) {
  const target = usePortal({ id });

  return target && createPortal(children, target);
}
